import tingle from 'tingle.js';
import moneyHelper from '../../helpers/money';
import { createUser, setContentProvider, setNumberOfUsers } from '../../actions';
import { GtmDataLayer } from '../../data/gtmDataLayer';
import { SelectField } from '../fields/selectField';
import Amount from "../../helpers/amount";


const cssClasses = {
    numberOfUsers: 'number-of-users',
    numberOfUsersBody: 'number-of-users__body',
    numberOfUsersFoot: 'number-of-users__foot',
    numberOfUsersInput: 'number-of-users__input',
    numberOfUsersHead: 'number-of-users__head',
    numberOfUsersLabel: 'number-of-users__label',
    numberOfUsersTooltip: 'number-of-users__tooltip',
    tooltip: 'tooltip',
    tooltipContent: 'tooltip__content',
    numberOfUsersPrice: 'number-of-users__price',
    numberOfUsersDescription: 'number-of-users__description'
};

export class NumberOfUsersInput {
    constructor(options) {
        this.store = options.store;
        this.state = this.store.getState();
        this.numberOfUsers = options.numberOfUsers;
        this.numberOfFreeUsers = options.numberOfFreeUsers ? options.numberOfFreeUsers : 0;
        this.id = options.id;
        this.userType = options.userType;
        this.name = options.name;
        this.minNumberOfUsers = parseInt(options.minNumberOfUsers, 10);
        this.maxNumberOfUsers = options.maxNumberOfUsers
            ? parseInt(options.maxNumberOfUsers, 10)
            : 999;
        this.amountPerUser = options.amountPerUser;
        this.description = options.description;
        this.tooltip = options.tooltip;
        this.dependency = parseInt(options.dependency, 10) !== 0 ? options.dependency : false;
        this.dependentOfModule = !!this.state.modules.find(module => module.internalId === this.dependency);
        this.dependentModuleIsActive = false;
        this.contentProviders = options.contentProviders;
        this.chosenProvider = options.chosenProvider;
        this.limits = options.limits;

        this.$el = this.createNumberOfUsersInputElement(
            options.name,
            options.tooltip,
            options.amountPerUser,
            options.unit
        );

        if (!this.state.users) {
            this.store.dispatch(
                createUser(
                    options.id,
                    options.userType,
                    options.minNumberOfUsers,
                    options.maxNumberOfUsers,
                    options.numberOfUsers,
                    options.amountPerUser,
                    options.name,
                    options.unit,
                    this.state.product.productCode,
                    this.state.product.packageCode,
                    options.dependency,
                    options.contentProviders
                )
            );
        }
        this.store.subscribe(this.update.bind(this));

        this.update();
    }

    createNumberOfUsersInputElement(
        name = '',
        tooltip = '',
        amount = 0,
        unit = ''
    ) {
        const $numberOfUsersElem = document.createElement('div');
        const $numberOfUsersBodyElem = document.createElement('div');
        const $numberOfUsersFootElem = document.createElement('div');
        const $numberOfUsersInputElem = document.createElement('div');
        const $numberOfUsersHeadElem = document.createElement('div');
        const $numberOfUsersLabelElem = document.createElement('label');
        const $numberOfUsersPriceElem = document.createElement('span');
        const $numberOfUsersLabelText = document.createTextNode(name);
        const $numberOfUsersTooltipElem = document.createElement('a');
        const $numberOfUsersDescriptionElem = document.createElement('span');
        const $numberOfUsersPriceText = document.createTextNode(
            `${moneyHelper.formatPrice(amount)} ${unit}`
        );

        $numberOfUsersLabelElem.setAttribute(
            'for',
            `number-of-users-${this.userType.toLowerCase()}`
        );
        $numberOfUsersLabelElem.appendChild($numberOfUsersLabelText);
        $numberOfUsersPriceElem.appendChild($numberOfUsersPriceText);

        $numberOfUsersElem.classList.add(cssClasses.firstView);
        $numberOfUsersElem.classList.add(cssClasses.numberOfUsers);
        $numberOfUsersBodyElem.classList.add(cssClasses.numberOfUsersBody);
        $numberOfUsersInputElem.classList.add(cssClasses.numberOfUsersInput, 'form-inline');
        $numberOfUsersHeadElem.classList.add(cssClasses.numberOfUsersHead);
        $numberOfUsersLabelElem.classList.add(cssClasses.numberOfUsersLabel, 'h5');
        $numberOfUsersTooltipElem.classList.add(
            cssClasses.numberOfUsersTooltip,
            cssClasses.tooltip
        );
        $numberOfUsersPriceElem.classList.add(cssClasses.numberOfUsersPrice, 'h5');
        $numberOfUsersDescriptionElem.classList.add(
            cssClasses.numberOfUsersDescription
        );

        this.$minusButton = this.createMinusButton();
        this.$numberInput = this.createNumberInput();
        this.$plusButton = this.createPlusButton();
        $numberOfUsersDescriptionElem.innerHTML = this.createDescription();

        $numberOfUsersInputElem.appendChild(this.$minusButton);
        $numberOfUsersInputElem.appendChild(this.$numberInput);
        $numberOfUsersInputElem.appendChild(this.$plusButton);

        $numberOfUsersHeadElem.appendChild($numberOfUsersLabelElem);
        if (tooltip !== '') {
            $numberOfUsersTooltipElem.innerHTML = `<span class="${
                cssClasses.tooltip
            }__content">${tooltip}</span>`;
            $numberOfUsersHeadElem.appendChild($numberOfUsersTooltipElem);
        }
        $numberOfUsersBodyElem.appendChild($numberOfUsersHeadElem);
        $numberOfUsersBodyElem.appendChild($numberOfUsersPriceElem);
        $numberOfUsersBodyElem.appendChild($numberOfUsersInputElem);

        $numberOfUsersElem.appendChild($numberOfUsersBodyElem);

        if (this.description) {
            $numberOfUsersFootElem.classList.add(cssClasses.numberOfUsersFoot);
            $numberOfUsersFootElem.appendChild($numberOfUsersDescriptionElem);
            $numberOfUsersElem.appendChild($numberOfUsersFootElem);
        }

        if (this.contentProviders.length) {
            this.modal = this.createModal();

            const el = new SelectField({
                store: this.store,
                stepId: 'step_1',
                id: `${this.userType}_contentProviders`,
                label: __('Content of vakorganisatie'),
                required: false,
                valid: true,
                options: this.contentProviders.map(i => ({ value: i.id, name: `&euro; ${i.amount} per Client: ${i.name}` })),
                $context: $numberOfUsersElem,
                FormCssClass: `${this.userType.toLowerCase()}_contentProvider_wrapper`,
                value: this.chosenProvider
            });
            el.getSelectElement().addEventListener('change', () => this.store.dispatch(setContentProvider(this.userType, this.contentProviders.filter(e => e.id === el.getSelectElement().value))))
            $numberOfUsersElem.appendChild(el.render());

            const $contentTooltip = document.createElement('span');
            $contentTooltip.classList.add('number-of-users__description');
            $contentTooltip.innerHTML = `<a href="#" class="werkprogramma">Bekijk hier</a> de extra voorwaarden`;
            $numberOfUsersElem.appendChild($contentTooltip);

            this.modal.setContent(`<div class="p-2"><p>Voor succesvol gebruik van het werkprogramma (Samenstel) voorziet Exact Online Jaarrekening in gebruik van vakcontent van derden. Hiertoe is er keuze uit één van de onderstaande opties. Het aantal vakcontentcliënten is hierbij altijd gelijk aan het aantal werkprogrammacliënten dat is inbegrepen in het abonnement.
</p>
<p style="font-weight: bold;">
Content of vakorganisatie<br>
€0.58 per Client: Content Samenstel - Auxilium <br>
€0.58 per Client: Content Samenstel - Extendum <br>
€0.58 per Client: Content Samenstel - Fiscount <br>
€0.58 per Client: Content Samenstel - Novak
</p>
<p>
<i>Let op. De content is een dienst van een derde als bedoeld in artikel 1.8 van de Exact Online Voorwaarden en maakt geen onderdeel uit van de Exact Software. Exact is niet verantwoordelijk voor de content en kan daarom niet aansprakelijk worden gehouden voor de content of het gebruik hiervan, zoals ook omschreven in artikel 17.4 van de Exact Online Voorwaarden.</i>
</p>
<p>
<i>U kunt via deze wizard geen content van Cygnus Atratus, NOAB of SRA bestellen. Neem contact op met uw Exact-accountmanager om deze content te bestellen. Opmerkingen:</i>
</p>
<p>
    <ul>
    <li>Content van Cygnus Atratus wordt geleverd en geïmplementeerd door Cygnus Atratus (CA).</li>
    <li>Om content van NOAB te bestellen, heeft u een NOAB-lidmaatschap met een NKS-licentie nodig.</li>
    <li>Om content van SRA te bestellen, heeft u een SRA-lidmaatschap nodig.</li>
    </ul>
</p>
</div>`);
            this.modal.addFooterBtn(
                'Sluiten',
                'btn btn-blue btn--next username-btn',
                () => {
                    this.modal.close();
                }
            );
            $numberOfUsersElem.querySelector('.werkprogramma').addEventListener('click', () => {
                this.modal.open();
            })
        }

        return $numberOfUsersElem;
    }

    // eslint-disable-next-line class-methods-use-this
    createModal() {
        // eslint-disable-next-line new-cap
        const modal = new tingle.modal({
            closeMethods: ['extra-modal', 'overlay', 'esc-key'],
            footer: true,
            beforeClose() {
                return true;
            }
        });

        return modal;
    }

    createMinusButton() {
        const $buttonElem = document.createElement('button');
        const $buttonInnerElem = document.createElement('span');
        const $buttonElemText = document.createTextNode('-');

        $buttonElem.type = 'button';
        $buttonElem.classList.add('btn');
        $buttonElem.classList.add('btn--minus', 'btn-sm');
        $buttonInnerElem.classList.add('btn__inner');
        $buttonInnerElem.appendChild($buttonElemText);
        $buttonElem.appendChild($buttonInnerElem);
        $buttonElem.disabled = (this.numberOfUsers === this.minNumberOfUsers);
        if (this.maxNumberOfUsers === this.minNumberOfUsers) {
            $buttonElem.disabled = true;
        }

        $buttonElem.addEventListener(
            'click',
            () => {
                if (this.numberOfUsers > this.minNumberOfUsers) {
                    this.numberOfUsers = parseInt(this.numberOfUsers, 10) - 1;
                    this.store.dispatch(
                        setNumberOfUsers(this.userType, this.numberOfUsers)
                    );

                    GtmDataLayer.removeFromCart({
                        name: this.name,
                        id: this.id,
                        price: this.amountPerUser,
                        quantity: this.numberOfUsers,
                        productCode: this.state.product.productCode,
                        packageCode: this.state.product.packageCode,
                    },
                    {
                        name: this.state.steps.find(step => step.current === true).name,
                        id: this.state.steps.find(step => step.current === true).id,
                    },
                    Amount.calculateTotalAmountIncludingExtras(this.state));
                }
            },
            true
        );

        return $buttonElem;
    }

    createNumberInput() {
        const $inputElem = document.createElement('input');

        $inputElem.type = 'number';
        $inputElem.id = `number-of-users-${this.userType.toLowerCase()}`;
        $inputElem.min = this.minNumberOfUsers;
        $inputElem.max = this.maxNumberOfUsers;
        $inputElem.value = this.minNumberOfUsers;
        $inputElem.classList.add('input--number', 'form-control', 'text-center');
        if (this.maxNumberOfUsers === this.minNumberOfUsers) {
            $inputElem.disabled = true;
        }

        $inputElem.addEventListener(
            'change',
            () => {
                const newNumberOfUsers = parseInt($inputElem.value, 10);
                const oldNumberOfUsers = this.numberOfUsers;

                if (
                    Number.isInteger(newNumberOfUsers) &&
                    newNumberOfUsers > this.minNumberOfUsers &&
                    newNumberOfUsers <= this.maxNumberOfUsers
                ) {
                    this.numberOfUsers = newNumberOfUsers;
                } else if (
                    Number.isInteger(newNumberOfUsers) &&
                    newNumberOfUsers > this.maxNumberOfUsers
                ) {
                    this.numberOfUsers = this.maxNumberOfUsers;
                } else {
                    this.numberOfUsers = this.minNumberOfUsers;
                }

                this.store.dispatch(
                    setNumberOfUsers(this.userType, this.numberOfUsers)
                );

                const gtmProductData = {
                    name: this.name,
                    id: this.id,
                    price: this.amountPerUser,
                    quantity: this.numberOfUsers,
                    productCode: this.state.product.productCode,
                    packageCode: this.state.product.packageCode,
                };
                const gtmStepData = {
                    name: this.state.steps.find(step => step.current === true).name,
                    id: this.state.steps.find(step => step.current === true).id,
                };

                if (oldNumberOfUsers > this.numberOfUsers) {
                    GtmDataLayer.removeFromCart(gtmProductData, gtmStepData, Amount.calculateTotalAmountIncludingExtras(this.state));
                } else {
                    GtmDataLayer.addToCart(gtmProductData, gtmStepData, Amount.calculateTotalAmountIncludingExtras(this.state));
                }

            },
            true
        );

        return $inputElem;
    }

    createPlusButton() {
        const $buttonElem = document.createElement('button');
        const $buttonInnerElem = document.createElement('span');
        const $buttonElemText = document.createTextNode('+');
        const $numberOfUsersTooltipElem = document.createElement('span');
        $numberOfUsersTooltipElem.classList.add(cssClasses.tooltipContent);

        $buttonElem.type = 'button';
        $buttonElem.classList.add('btn');
        $buttonElem.classList.add('btn--plus', 'btn-sm');
        $buttonInnerElem.classList.add('btn__inner');
        $buttonInnerElem.appendChild($buttonElemText);
        $buttonElem.appendChild($buttonInnerElem);
        $buttonElem.disabled = (this.numberOfUsers === this.maxNumberOfUsers);
        if (this.maxNumberOfUsers === this.minNumberOfUsers) {
            $buttonElem.disabled = true;
            $numberOfUsersTooltipElem.innerHTML = __('No additional users or administrations can be added to this package. Need more? Choose one of our other packages.');
            $buttonElem.appendChild($numberOfUsersTooltipElem);
        }

        $buttonElem.addEventListener(
            'click',
            () => {
                if (this.numberOfUsers < this.maxNumberOfUsers) {
                    this.numberOfUsers = parseInt(this.numberOfUsers, 10) + 1;
                    this.store.dispatch(
                        setNumberOfUsers(this.userType, this.numberOfUsers)
                    );

                    GtmDataLayer.addToCart({
                        name: this.name,
                        id: this.id,
                        price: this.amountPerUser,
                        quantity: this.numberOfUsers,
                        productCode: this.state.product.productCode,
                        packageCode: this.state.product.packageCode,
                    },
                    {
                        name: this.state.steps.find(step => step.current === true).name,
                        id: this.state.steps.find(step => step.current === true).id,
                    }, Amount.calculateTotalAmountIncludingExtras(this.state));
                }
            },
            true
        );

        return $buttonElem;
    }

    toggleButtons() {
        this.$minusButton.disabled = (this.numberOfUsers === this.minNumberOfUsers);
        this.$plusButton.disabled = (this.numberOfUsers === this.maxNumberOfUsers);

        if (this.limits) {
            Object.keys(this.limits).forEach((key) => {
                const { limit, packages } = this.limits[key];
                if (packages.indexOf(this.userType) > -1) {
                    const currentValue = this.state.users.reduce((acc, curr) => {
                        if (packages.indexOf(curr.userType) > -1) {
                            return acc + curr.numberOfUsers;
                        }

                        return acc;
                    }, 0);

                    if (currentValue >= limit) {
                        this.$plusButton.disabled = true;
                    }
                }
            });
        }

    }

    createDescription() {
        return this.description;
    }

    updateNumberOfUsersInput(numberOfUsers) {
        this.numberOfUsers = numberOfUsers;
        this.$numberInput.value = numberOfUsers;
    }

    toggleVisibility() {
        const dependentModule = this.state.modules.find(module => module.internalId === this.dependency);

        this.dependentModuleIsActive = dependentModule ? dependentModule.active : true;
        this.$el.classList.toggle('visually-hidden', (dependentModule && !this.dependentModuleIsActive));
        this.$el.classList.toggle('bounce', (dependentModule && this.dependentModuleIsActive && !this.firstView));
    }

    update() {
        this.state = this.store.getState();

        const updatedUser = this.state.users.find(
            user => user.userType === this.userType
        );

        this.toggleButtons();
        this.updateNumberOfUsersInput(updatedUser.numberOfUsers);
        if (this.dependency) {
            this.toggleVisibility();
        }

        const wrap = document.querySelector(`.${this.userType.toLowerCase()}_contentProvider_wrapper`);
        if (this.contentProviders.length && wrap) {
            if (updatedUser.numberOfUsers > 0) {
                wrap.classList.remove('visually-hidden');
            } else {
                wrap.classList.add('visually-hidden');
            }
        }
    }

    render() {
        return this.$el;
    }
}

export default NumberOfUsersInput;
